// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1zJax","footer":"ChangeClinic_footer__3BWf6"};